module.exports = __webpack_public_path__ + "img/img-4-desk.9384c0a4.jpg";